module.exports = __webpack_public_path__ + "media/bootstrap-icons/geo-alt-2d2f3b34.svg";